export default __webpack_public_path__ + "static/media/Group 3182@2x.522a1d8a.png";